<template>
    <div id="chart4" class="plot mosq"></div>
</template>

<script>
import $ from "jquery";
// import jqplot from '@/assets/js/jqplot/jquery.jqplot.min.js';
// import MeterGaugeRenderer from '@/assets/js/jqplot/jqplot.meterGaugeRenderer.min.js';

export default {
  data() {
    return {
      // s1: [52200],
    };
  },
  created() {
    // $(document).ready(function(){
    //     var s1 = [52200];
    //     var plot = $.jqplot('chart3',[s1],{
    //         seriesDefaults: {
    //             renderer: $.jqplot.MeterGaugeRenderer,
    //             rendererOptions: {
    //                 min: 100,
    //                 max: 500,
    //                 intervals:[200, 300, 400, 500],
    //                 intervalColors:['#66cc66', '#93b75f', '#E7E658', '#cc6666']
    //             }
    //         }
    //     });
    // });
  },
  computed: {},
  mixins: [],
};
</script>
<style>
.plot.mosq{
    width: 320px; height: 200px;
}
@media (min-width: 2737px) and (max-width: 7680px) {
    .plot.mosq{
        width: 580px; height: 340px;
    }
}
</style>
